import {
    Characteristics,
    Filter,
    Selection,
    valueOf
} from "@encoway/c-services-js-client"
import { L10n } from "@encoway/l10n"

import { getCatalogService } from "../app/catalogServiceHolder"

export async function initializeTranslations() {
    const catalogService = getCatalogService()
    const lang = L10n.currentFullLocale()

    const productGroupFilter = Filter.productGroupFilter()
        .id("UI_TRANSLATIONS")
        .includeSubgroups(true)
    const characteristics = new Characteristics().id("long_text_gui")
    const selectionQuery = new Selection()
        .limit(1000)
        .filter(productGroupFilter)
        .characteristics(characteristics)

    const translationResult = await catalogService.products(
        selectionQuery,
        lang
    )

    const translations: any = {}
    translationResult.products.forEach((translation: any) => {
        translations[translation.id] =
            valueOf(translation, "long_text_gui") || translation.name
    })
    L10n.source("ui", { [lang]: translations }, true)
    await L10n.reloadResources(lang)
}
